const testingVar = (variable: string) =>
  process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT' ? variable : undefined;

export default testingVar;
